import { Modal } from '../shared/modal';
import FormSubmitHelper from '../../helpers/form-submit-helper';

export enum FormType {
  Part = 'REQUEST_ORIGINAL_PARTS',
  Equipment = 'REQUEST_ACCESSORIES',
  ReadRequestAccessories = 'READ_REQUEST_ACCESSORIES',
  ReadRequestParts = 'READ_REQUEST_PARTS'
}

export interface UrgentRequestFormData {
  itemId: number;
  companyId?: string;
  contactPerson?: string;
  phone?: string;
  fax?: string;
  orderId: string;
  materialNumber: string;
  description: string;
  quantity: number;
  formType: FormType | null;
  equipment: boolean;
  salesTicketId?: number;
}

export default class UrgentRequestForm implements Modal {

  private static readonly template = $('#js-urgencyRequestModalTemplate').html();
  private static readonly partsTitle = $('#js-urgencyRequestModalTemplate').data('parts-title') as string;
  private static readonly equipmentTitle = $('#js-urgencyRequestModalTemplate').data('equipment-title') as string;

  constructor(private salesOrder: UrgentRequestFormData) {}

  open(): void {
    window.ACC.colorbox.open(false, {
      html: this.getTemplateHtml(),
      maxWidth: '1000px',
      width: '100%',
      onComplete: () => {
        this.bindFormValidation();
        this.bindEnableSubmit();
        this.bindClose();
        this.bindSubmitOverlay();
        $('body').addClass('-print-modal');
      },
      onClosed: () => {
        $('body').removeClass('-print-modal');
      },
    });
  }

  static close(): void {
    $.colorbox.close();
  }

  private bindFormValidation(): void {
    if (this.isPartsForm() && !this.isReadOnly()) {
      $('.js-chassisNumber').on('blur', (e) => $(e.target).parsley().validate());
    }
  }

  private bindEnableSubmit(): void {
    if (this.isPartsForm()) {
      $('.js-chassisNumber').on('input', () => {
        $('.js-submitUrgencyRequest').prop('disabled', !$('.js-urgencyRequestForm').parsley().isValid());
      });
    }
  }

  private bindClose(): void {
    $('.js-cancelUrgencyRequest').on('click', () => UrgentRequestForm.close());
  }

  private bindSubmitOverlay(): void {
    FormSubmitHelper.initForm($('.js-urgencyRequestForm'));
  }

  private isPartsForm(): boolean {
    return !this.salesOrder.equipment;
  }

  private isReadOnly(): boolean {
    return !!this.salesOrder.salesTicketId;
  }

  private getTemplateHtml(): string {
    const form = $(UrgentRequestForm.template);

    Object.keys(this.salesOrder).forEach((key) => {
      const input = form.find(`[name="${key}"]`);
      const inputType = input.attr('type');
      const value = this.salesOrder[key] as string;
      if (inputType === 'radio' || inputType === 'checkbox') {
        input.removeAttr('checked');
        input.filter(`[value=${value}]`).attr('checked', 'checked');
      } else if (input.is('textarea')) {
        input.html(value);
        input.attr('rows', 2);
      } else {
        input.attr('value', value);
      }
    });

    form.find('.js-title').html(this.isPartsForm() ? UrgentRequestForm.partsTitle : UrgentRequestForm.equipmentTitle);
    if (!this.isPartsForm()) {
      form.find('.js-chassisNumberContainer .mandatory').hide();
      form.find('.js-chassisNumber').prop('required', false);
      form.find('.js-submitUrgencyRequest').prop('disabled', false);
    }

    if (this.isReadOnly()) {
      form.find('input, textarea').prop('readonly', true);
      form.find('input[type=checkbox], input[type=radio]').prop('disabled', true);
      form.find('.js-sendFeedback').hide();
    }

    return form[0].outerHTML;
  }
}
